module.exports = __webpack_public_path__ + "static/media/hongdanshan_package.81fd091a.webp";